export const convertBase64ToJSON = (base64Data:string) => {
    const padding = '='.repeat((4 - base64Data.length % 4) % 4);
    const base64 = (base64Data + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const uint8Array = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; i++) {
        uint8Array[i] = rawData.charCodeAt(i);
    }
    const textDecoder = new TextDecoder('utf-8');
    const decodedData = textDecoder.decode(uint8Array);
    return JSON.parse(decodedData);
};

export const calculateFileSizeInMB = (base64String: string) => {
    try {
        if (base64String) {
            const base64WithoutHeader = base64String;
            const byteCharacters = atob(base64WithoutHeader);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray]);
        
            // Tamaño en Megabytes
            return blob.size / (1024 * 1024);
        }
        return 0;
    } catch (e) { return 0; }
};

export const descargarBase64 = (base64Data: string, mimeType: string, fileName: string) => {
    const decodedData = atob(base64Data);
    const byteArray = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
        byteArray[i] = decodedData.charCodeAt(i);
    }
    const blob = new Blob([byteArray], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

export const descargarCsvArchivos = (archivos?: Array<{ NombreArchivo: string; Base64: string }>) => {
    (archivos ?? []).forEach((archivo, index) => {
        // Escalonado: los navegadores pueden bloquear varias descargas simultaneas
        setTimeout(() => descargarBase64(archivo.Base64, 'text/csv;charset=iso-8859-1', archivo.NombreArchivo), (index + 1) * 400);
    });
};
